import React from 'react'
import { GridContext } from './context'

export const withGridContext = <T extends object>(Component: React.ComponentType<T>) => {
    const HocComponent: React.ComponentType<T> = (props: any) => (
        <GridContext.Consumer>
            {(context) => <Component {...context} {...(props as T)} />}
        </GridContext.Consumer>
    )
    return HocComponent
}
